/**
 * Utility functions for cookie operations
 */
export default {
    /**
     * Get cookie value by name
     * @param name - Cookie name
     * @returns Cookie value or null if not found
     */
    getCookie: (name) => {
        var _a;
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            const cookieValue = (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(';').shift();
            return cookieValue ? decodeURIComponent(cookieValue) : null;
        }
        return null;
    },
    /**
     * Set cookie with name, value, and expiration
     * @param name - Cookie name
     * @param value - Cookie value
     * @param domain - Cookie domain (default: ".inspectpoint.com" for cross-subdomain)
     * @param secure - Force secure flag (default: auto-detect based on HTTPS)
     * @param days - Days until expiration (default: 365)
     */
    setCookie: (name, value, days, options) => {
        const defaultDays = 365;
        const defaultSecure = typeof window !== 'undefined' && window.location.protocol === 'https:';
        const hostname = typeof window !== 'undefined' ? window.location.hostname : undefined;
        const defaultDomain = hostname && (hostname === 'inspectpoint.com' || hostname.endsWith('.inspectpoint.com'))
            ? '.inspectpoint.com'
            : '';
        const domain = (options === null || options === void 0 ? void 0 : options.domain) || defaultDomain;
        const expires = new Date(Date.now() + (days || defaultDays) * 24 * 60 * 60 * 1000).toUTCString();
        const parts = [
            `${name}=${encodeURIComponent(value)}`,
            `expires=${expires}`,
            `path=${(options === null || options === void 0 ? void 0 : options.path) || '/'}`,
            (options === null || options === void 0 ? void 0 : options.sameSite) ? `SameSite=${options.sameSite}` : '',
            domain ? `domain=${domain}` : '',
            (options === null || options === void 0 ? void 0 : options.secure) || defaultSecure ? 'Secure' : ''
        ].filter(Boolean);
        document.cookie = parts.join('; ');
    },
    /**
     * Delete cookie by name
     * @param name - Cookie name to delete
     * @param options - Cookie deletion options (should mirror the original cookie settings)
     */
    deleteCookie: (name, options) => {
        const hostname = typeof window !== 'undefined' ? window.location.hostname : undefined;
        const defaultDomain = hostname && (hostname === 'inspectpoint.com' || hostname.endsWith('.inspectpoint.com'))
            ? '.inspectpoint.com'
            : '';
        const path = (options === null || options === void 0 ? void 0 : options.path) || '/';
        const domain = (options === null || options === void 0 ? void 0 : options.domain) || defaultDomain;
        const parts = [
            `${name}=`,
            `expires=Thu, 01 Jan 1970 00:00:00 UTC`,
            `path=${path}`,
            domain ? `domain=${domain}` : '',
            'SameSite=Strict'
        ].filter(Boolean);
        document.cookie = parts.join('; ');
        if (domain) {
            const fallbackParts = [`${name}=`, `expires=Thu, 01 Jan 1970 00:00:00 UTC`, `path=${path}`, 'SameSite=Strict'];
            document.cookie = fallbackParts.join('; ');
        }
        if (path !== '/') {
            const rootParts = [
                `${name}=`,
                `expires=Thu, 01 Jan 1970 00:00:00 UTC`,
                'path=/',
                domain ? `domain=${domain}` : '',
                'SameSite=Strict'
            ].filter(Boolean);
            document.cookie = rootParts.join('; ');
            if (domain) {
                const rootFallbackParts = [`${name}=`, `expires=Thu, 01 Jan 1970 00:00:00 UTC`, 'path=/', 'SameSite=Strict'];
                document.cookie = rootFallbackParts.join('; ');
            }
        }
    }
};
